const GoogleAnalytics = {
    // Disable Scratch's analytics
    event () {}
};

export default GoogleAnalytics;
